import WithRender from "../../templates/tables/quantityTable.html";
import { mapGetters, mapActions } from "vuex";
export default WithRender({
  computed: {
    ...mapGetters(["getFileCopyChecked"]),
    fileCopy: {
      get: function () {
        return this.getFileCopyChecked;
      },
      set: function (newValue) {
        this.setFileCopyChecked(newValue);
      }
    },
    name: () => {
      return "Quantity";
    }
  },
  methods: {
    ...mapActions(["setFileCopyChecked"])
  }
});
